/**
 * Translations.
 */
export default {
  ACTION: {
    SAVE: 'Guardar',
    SUBMIT: 'Submeter'
  },
  ERROR: {
    CANCEL_COUNTERPART: 'Erro ao cancelar contrapartida',
    COUNTERPART_DETAILS_SUBMIT: 'Erro ao submeter contrapartida',
    DELETE_ATTACHMENT: 'Erro ao eliminar anexo',
    DELETE_LINK: 'Erro ao eliminar link',
    ERROR: 'Erro',
    FILE_SIZE: 'O ficheiro selecionado excede o limite de 8Mb',
    MAX_FILES_UPLOAD: 'Não é possível submeter mais do que 8 MB de uma vez',
    PUBLISHED_AT_ERROR: 'A data de publicação é obrigatória'
  },
  HEADER: {
    APPROVED_BY: 'Aprovado por',
    ATTACHMENT: 'Anexos',
    COMMENT: 'Comentário',
    CONFIRMATION_DATE: 'Confirmação',
    CURRENT_PARTNER_TASKS: 'P. Corr',
    DESCRIPTION: 'Descrição',
    END_DATE: 'Data fim',
    LINK: 'Links',
    MANAGER_COMMENT: 'Comentário gestor',
    MONTH: 'Mês',
    PERIODICITY: 'Periodicidade',
    PREVIOUS_PARTNER_TASKS: 'P. Ant',
    REQUIRED: 'Obrigatório',
    START_DATE: 'Data início',
    STATE: 'Estado',
    SUBMISSION_DATE: 'Submissão'
  },
  LABEL: {
    ATTACHMENTS: 'Anexos',
    ATTACHMENTS_UPLOADED: 'Anexos Carregados',
    CANCEL_COUNTERPART: 'Cancelar',
    CLOSE: 'Fechar',
    COMMENT: 'Comentário',
    CONFIRM: 'Confirmar',
    DESCRIPTION: 'Descrição',
    FILTER_MONTH_APR: 'Abril',
    FILTER_MONTH_AUG: 'Agosto',
    FILTER_MONTH_DEC: 'Dezembro',
    FILTER_MONTH_FEB: 'Fevereiro',
    FILTER_MONTH_JAN: 'Janeiro',
    FILTER_MONTH_JUL: 'Julho',
    FILTER_MONTH_JUN: 'Junho',
    FILTER_MONTH_MAR: 'Março',
    FILTER_MONTH_MAY: 'Maio',
    FILTER_MONTH_NOV: 'Novembro',
    FILTER_MONTH_OCT: 'Outubro',
    FILTER_MONTH_SEP: 'Setembro',
    LINK: 'Link',
    LINKS: 'Links',
    LINKS_UPLOADED: 'Links carregados',
    MONTH: 'Mês',
    PUBLISHED_AT: 'Data de publicação',
    STATE: 'Estado',
    SUBMIT_COUNTERPART: 'Submeter',
    YEAR: 'Ano'
  },
  SENTENCE: {
    CANCEL_COUNTERPART_TEXT:
      'Tem a certeza que pretende cancelar a submissão da contrapartida?',
    CONFIRM_SUBMIT_COUNTERPART_TEXT:
      'Tem a certeza que deseja submeter a contrapartida?',
    NO_ROWS_ATTACHMENT: 'Sem anexos'
  },
  SUCCESS: {
    ATTACHMENT_DELETED: 'Anexo eliminado',
    CANCEL_COUNTERPART: 'Contrapartida cancelada',
    COUNTERPART_DETAILS_SUBMIT: 'Detalhes de contrapartida submetidos',
    LINK_DELETED: 'Link eliminado',
    SUCCESS: 'Sucesso'
  },
  TOOLTIP: {
    ADD_LINK: 'Novo link',
    APPROVED_BY: 'Contrapartida aprovada por',
    ATTACHMENT: 'Anexos',
    COMMENT: 'Comentário',
    CONFIRMATION_DATE: 'Data de confirmação da contrapartida',
    CURRENT_PARTNER_TASKS:
      'Nº de registos do periodo corrente por submeter por parte do parceiro',
    DESCRIPTION: 'Descrição',
    END_DATE: 'Data fim',
    LINK: 'Links',
    MANAGER_COMMENT: 'Comentário do gestor',
    MONTH: 'Mês',
    PERIODICITY: 'Periodicidade',
    PREVIOUS_PARTNER_TASKS:
      'Nº de registos do periodo anterior por submeter por parte do parceiro',
    REMOVE_LINK: 'Remover Link',
    REQUIRED: 'Obrigatório',
    START_DATE: 'Data início',
    STATE: 'Estado',
    SUBMISSION_DATE: 'Data da submissão da contrapartida'
  }
};
